module.exports = __webpack_public_path__ + "img/1507278154.d09e26a9.jpg";